import { useRef } from "react"

export type NewWindowProps = {
  height?: number
  width?: number
  top?: number
  left?: number
  status?: boolean
  menuBar?: boolean
  titleBar?: boolean
}

export const useOpenNewWindow = () => {
  const newWindowRef = useRef<Window | null>(null)
  const openNewWindow = (
    url: string,
    target: string,
    isSameWindows: boolean = false,
    props: NewWindowProps = {
      height: window.screen.height,
      width: window.screen.width,
      top: 0,
      left: 0,
      status: false,
      menuBar: false,
      titleBar: false,
    },
  ) => {
    const features = isSameWindows
      ? ""
      : [
          `height=${props.height}`,
          `width=${props.width}`,
          `top=${props.top}`,
          `left=${props.left}`,
          `status=${props.status ? "yes" : "no"}`,
          `menuBar=${props.menuBar ? "yes" : "no"}`,
          `titleBar=${props.titleBar ? "yes" : "no"}`,
        ].join(",")

    if (newWindowRef.current && !newWindowRef.current.closed) {
      newWindowRef.current.focus()
    } else {
      newWindowRef.current = window.open(url, isSameWindows ? "_blank" : target, features)
      if (newWindowRef.current) {
        newWindowRef.current.focus()
      }
    }

    return newWindowRef.current
  }

  return openNewWindow
}
